export const ESTADOS_CURRICULUM = [
  'PENDIENTE_REVISION',
  'ENTREVISTADO_NO_CONTRATADO',
  'CONTRATADO',
  'APTO_FUTURAS_BUSQUEDAS',
  'NO_APTO_PERFIL',
];

export const ESTADO_LABELS = {
  PENDIENTE_REVISION: 'Pendiente de revisión',
  ENTREVISTADO_NO_CONTRATADO: 'Entrevistado (no contratado)',
  CONTRATADO: 'Contratado',
  APTO_FUTURAS_BUSQUEDAS: 'Apto futuras búsquedas',
  NO_APTO_PERFIL: 'No apto para el perfil',
};

export const ESTADO_COLORS = {
  PENDIENTE_REVISION: 'default',
  ENTREVISTADO_NO_CONTRATADO: 'orange',
  CONTRATADO: 'green',
  APTO_FUTURAS_BUSQUEDAS: 'blue',
  NO_APTO_PERFIL: 'red',
};

/** Color sólido para punto / borde de fila */
export const ESTADO_HEX = {
  PENDIENTE_REVISION: '#8c8c8c',
  ENTREVISTADO_NO_CONTRATADO: '#fa8c16',
  CONTRATADO: '#389e0d',
  APTO_FUTURAS_BUSQUEDAS: '#1677ff',
  NO_APTO_PERFIL: '#cf1322',
};

export const estadoOptions = ESTADOS_CURRICULUM.map((value) => ({
  value,
  label: ESTADO_LABELS[value],
}));

export const SEXOS_CURRICULUM = ['M', 'F'];

export const SEXO_LABELS = {
  M: 'Masculino',
  F: 'Femenino',
};

export const sexoOptions = SEXOS_CURRICULUM.map((value) => ({
  value,
  label: SEXO_LABELS[value],
}));
